import React from 'react';
import { AVATAR_VARIANT, AVATAR_SIZE, AVATAR_SHADOW, AVATAR_BG_COLOR } from '../Avatar/types';
import { Avatar } from '../Avatar';
import { Tooltip } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { FacebookPhotoProps } from './types';

export const FacebookPhoto: React.FC<FacebookPhotoProps> = ({ fbPost }) => {
  const hasValidUrl = fbPost?.postPictureUrl !== '';

  const AVATAR_COMMON_STYLES = {
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'transform 0.4s',
    '&:hover': {
      transform: 'scale(1.04)',
    },
  } as const;

  const COMMON_AVATAR_PROPS = {
    variant: AVATAR_VARIANT?.ROUNDED,
    size: AVATAR_SIZE?.XXL,
    shadow: AVATAR_SHADOW?.SM,
  } as const;

  return (
    <>
      {hasValidUrl ? (
        <Avatar
          {...COMMON_AVATAR_PROPS}
          alt="Generated image"
          src={fbPost.postPictureUrl}
          onClick={() => {
            window.open(fbPost.postPictureUrl, '_blank', 'noopener,noreferrer');
          }}
          sx={AVATAR_COMMON_STYLES}
        />
      ) : (
        <Tooltip title="Kép nem található" arrow placement="top">
          <Avatar
            {...COMMON_AVATAR_PROPS}
            alt="Empty photo"
            bgColor={AVATAR_BG_COLOR.TRANSPARENT}
            sx={AVATAR_COMMON_STYLES}>
            <ErrorOutline fontSize="large" sx={{ color: '#344767' }} />
          </Avatar>
        </Tooltip>
      )}
    </>
  );
};
